import { createApp } from 'vue';

import App from '@/App.vue';
import { configureDependencies } from '@/app/configureDependencies';
import router from '@/presentation/router';
import i18n from '@/i12e/i18n';
import posthog from '@/i12e/plugins/posthog';
import dayjs from '@/i12e/plugins/dayjs';
import vuetify from '@/i12e/plugins/vuetify';
import { PERFORMANCE_TELEMETRY_KEY } from '@/app/telemetry/performanceTelemetry';

/**
 * Creates and wires the Kairos application.
 *
 * This is the composition root: framework plugins and data adapters are
 * assembled here so presentation composables depend only on domain services.
 *
 * @returns {Object} Configured Vue application instance.
 */
export const createKairosApp = () => {
  const app = createApp(App);
  const { performanceTelemetry } = configureDependencies();
  app.provide(PERFORMANCE_TELEMETRY_KEY, performanceTelemetry);

  app.use(router);
  app.use(i18n);
  app.use(posthog);
  app.use(dayjs);
  app.use(vuetify);

  return app;
};
